import React, { useEffect, useState } from "react";

import Corpo from "../components/Corpo";
import ImgPerfilVazio from "../assets/img/perfil.jpg";
import LazyLoad from "react-lazy-load";
import Loading from "../components/Loading";
import Debounce from "../components/Debounce";

import { getRanking } from "../services/ranking-service";

/* eslint-disable */
export default function TabRanking(props) {
  const [rankings, setRankings] = useState([]);
  const [clone, setClone] = useState([]);
  const [tipo, setTipo] = useState('singleplayer');

  const [showPesquisa, setShowPesquisa] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [txtPesquisa, setTxtPesquisa] = useState("");

  const debouncedSearchTerm = Debounce(txtPesquisa, 500);

  let reseta = () => {
    setRankings(clone);
  };

  let rolar = () => {

  };

  let checkImg = (img) => {
    return img ? img : ImgPerfilVazio;
  };

  let togglePesquisa = () => {
    setShowPesquisa(!showPesquisa);
  };

  let changeTipo = (tipo) => {
    setTipo(tipo);
    setShowLoading(true);
    setTxtPesquisa("");

    findRanking(tipo);
  };

  let findRanking = (tipo) => {
    getRanking(tipo).then((res) => {
      var rankings = res.data.content || [];
      rankings.map((ranking, key) => {
        ranking.posicao = key + 1;
        return ranking;
      });

      setRankings(rankings);
      setClone(rankings);
      setShowLoading(false);
    });
  };

  useEffect(() => {
    const abortController = new AbortController();

    setShowLoading(true);
    findRanking(tipo);

    return function cleanup() {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    const abortController = new AbortController();

    if (debouncedSearchTerm) {
      if (txtPesquisa.length > 0) {
        let newRanking = rankings.filter((u) => {
          return u.nomeUsuario.toLowerCase().includes(txtPesquisa.toLowerCase());
        });
        setRankings(newRanking);
      } else {
        reseta();
      }
    }
    return function cleanup() {
      abortController.abort();
    };
  }, [debouncedSearchTerm, txtPesquisa]);

  return (
    <Corpo {...props}>
      <Loading show={showLoading}>Carregando Ranking...</Loading>

      <div name="tab-ranking" className="view-container tab-content">
        <div className="view-ranking pane pane-game">
          <div
            className="scroll-content ionic-scroll scroll-content-false  has-tabs-top"
            style={{ top: "56px", overflow: "hidden" }}
          >
            <div className="view-sub-menu" style={{ height: "20px" }}>
              <div style={{ paddingLeft: "3%" }}>
                <span
                  style={{ cursor: "pointer", float: "left" }}
                  onClick={() => togglePesquisa()}
                  className="ion-search"
                />
              </div>
              <ul>
                <li
                  className={tipo === 'singleplayer' ? "active" : "cursor-pointer"}
                  onClick={() => changeTipo('singleplayer')}
                >
                  <div>Singleplayer</div>
                </li>
                <li
                  className={tipo === 'multiplayer' ? "active" : "cursor-pointer"}
                  onClick={() => changeTipo('multiplayer')}
                >
                  <div>Multiplayer</div>
                </li>
              </ul>
            </div>
            <div
              ng-show="pesquisar"
              style={{ display: showPesquisa === false ? "none" : "" }}
            >
              <label className="item item-input">
                <input
                  type="search"
                  placeholder="Pesquisar"
                  className="ng-pristine ng-untouched ng-valid ng-empty"
                  value={txtPesquisa}
                  onChange={(e) => setTxtPesquisa(e.target.value)}
                />
              </label>
            </div>
            <h2>Ranking</h2>
            <div className="content-table">
              <header className="content-table-header">
                <div className="row  row-center">
                  <div className="col">Posição</div>
                  <div className="col col-50">Jogador</div>
                  <div className="col text-center ">Pontos</div>
                  <div className="col text-center out-off-layout">Vitórias</div>
                </div>
              </header>
              <div className="content-table-itens" style={{ height: "100%" }}>
                <div
                  className="scroll"
                  style={{
                    transform: "translate3d(0px, 0px, 0px) scale(1)",
                    overflow: "auto",
                    maxHeight: "522px",
                  }}
                  onScroll={() => rolar()}
                >
                  <div className="disable-user-behavior">
                    <div className="list">
                      {rankings && rankings.map((ranking, key) => (
                        <div className="row row-center" key={key}>
                          <div className="col ng-binding">{ranking.posicao}º</div>
                          <div className="col text-center">
                            <LazyLoad
                              width={48}
                              height={48}
                              debounce={false}
                              offsetVertical={500}
                            >
                              <img
                                src={checkImg(ranking.urlAvatar)}
                                alt="user"
                              />
                            </LazyLoad>
                          </div>
                          <div className="col-50">
                            <span className="ng-binding">
                              {ranking.nomeUsuario}
                            </span>
                          </div>
                          <div className="col text-center ng-binding">
                            {ranking.pontuacao}
                          </div>
                          <div className="col text-center out-off-layout">
                            {ranking.pontuacao}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
